import { Link, useNavigate } from "react-router-dom";
import HomeIcon from "../../Assets/Icons/outline/home-hashtag.svg";
import TaskIcon from "../../Assets/Icons/outline/task-square.svg";
import UsersIcon from "../../Assets/Icons/outline/profile-2user-white.svg";
import InfoIcon from "../../Assets/Icons/outline/info-circle.svg";
import LogoutIcon from "../../Assets/Icons/outline/logout.svg";
import ProjectClosed from "../../Assets/Icons/outline/archive-2-white.svg";
import GearIcon from "../../Assets/Icons/outline/gear-svgrepo-com-white.svg";
import MagicStar from "../../Assets/Icons/outline/magic-star.svg";
import AuthLogo from "../../Assets/Images/logo-auth.png";
import { isSuperAdmin } from "../../utils/auth";

function Sidebar({ openSideBar }) {
	const navigate = useNavigate();

	return (
		<aside
			className={`fixed top-10 ml-0 pb-[80px] z-40 w-20 h-screen transition-transform ${
				openSideBar ? "transform-none" : "-translate-x-full"
			} sm:translate-x-0`}
		>
			<div className="h-full overflow-y-auto bg-black rounded-full">
				<ul className="space-y-2 px-3 py-4 font-medium">
					<li className="mb-10">
						<Link to="/" className="text-white">
							<img src={AuthLogo} alt="" className="mx-auto" />
						</Link>
					</li>
					<li>
						<Link to="/dashboard" className="p-2 text-white">
							<img src={HomeIcon} alt="" className="mx-auto h-[40px] w-[40px]" />
						</Link>
					</li>
					<li>
						<Link to="/project" className="p-2 text-white">
							<img src={TaskIcon} alt="" className="mx-auto h-[40px] w-[40px]" />
						</Link>
					</li>
					<li>
						<Link to="/project-close" className="p-2 text-white">
							<img src={ProjectClosed} alt="" className="mx-auto h-[40px] w-[40px] " />
						</Link>
					</li>
					{isSuperAdmin() && (
						<li>
							<Link to="/points" className="p-2 text-white">
								<img src={MagicStar} alt="" className="mx-auto h-[40px] w-[40px]" />
							</Link>
						</li>
					)}
					{(localStorage.getItem("role") === "Superadmin" ||
						localStorage.getItem("role") === "Manager" ||
						localStorage.getItem("role") === "Lead Designer") && (
						<li>
							<Link to="/master/member" className="p-2 text-white">
								<img src={GearIcon} alt="" className="mx-auto h-[40px] w-[40px]" />
							</Link>
						</li>
					)}
					<li>
						<Link to="/information" className="p-2 text-white">
							<img src={InfoIcon} alt="" className="mx-auto h-[40px] w-[40px]" />
						</Link>
					</li>
				</ul>
				<div className="text-white absolute bottom-20 w-full">
					<Link
						onClick={() => {
							localStorage.clear();
						}}
						to="/login"
						className="p-2 text-white"
					>
						<img src={LogoutIcon} alt="" className="mx-auto h-[40px] w-[40px]" />
					</Link>
				</div>
			</div>
		</aside>
	);
}

export default Sidebar;
